<template>
  <div :class="base_class">
    <div class="validation_request_order_offer_agency_head">
      <div class="head">
        <h4>Agence {{agency.display_name}}</h4>
        <!-- <button class="btn btn-success" @click="toggle">
          <i class="fa fa-caret-up" v-if="view_details"></i>
          <i class="fa fa-caret-down" v-else></i>
          <span>Détails</span>
        </button> -->
      </div>
      <p class="validation_request_order_offer_agency_organisation">
        <em>Organisation: {{agency.organization.display_name}}</em>
      </p>
      <!-- <hr> -->
    </div>
    <div class="validation_request_order_offer_agency_container" >
      <div>
          <h5>Adresse</h5>
          <ul>
            <li>{{agency.street_line1}}</li>
            <li v-if="agency.street_line2">{{agency.street_line2}}</li>
            <li>{{agency.zipcode}} {{agency.city}}</li>
            <li>{{agency.state}} {{agency.decoded_country}}</li>
          </ul>
          <h5>Contact</h5>
          <ul>
            <li>Tél. : {{agency.phone}} </li>
            <li>Permanence téléphonique : {{agency.final_hotline_phone}} </li>

          </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name:"ValidationRequestableOrderOfferAgency",
  props:["agency","is_details"],
  data() {
    return {
      detailed_view:false,
    }
  },

  methods : {
    toggle() {
      this.detailed_view = !this.detailed_view
    },
  },

  computed: {
    view_details () {
      return this.detailed_view
    },

    base_class() {
      if (this.is_details == true)
        return "validation_request_order_offer_agency detailed-view"
      return "validation_request_order_offer_agency"
    }
  },
}
</script>
<style scoped>

.validation_request_order_offer_agency_head {
  text-align: center;
  /*border-left: solid 1px lightgray;*/
  border-bottom: solid 1px lightgray;
  padding-left: 15px;
  padding-right: 15px;

}

.validation_request_order_offer_agency_container{
  display: flex;
  /*border-left: solid 1px lightgray;*/
  padding-right: 15px;
  padding-left: 15px;

}

.validation_request_order_offer_agency_address{

}

.validation_request_order_offer_agency_organisation {

}

.validation_request_order_offer_agency {
  background-color: white;
  min-width: 20%;
}

.head {
  width: 100%;
}

.head h4 {
  display: inline-block;
}

.head button {
  display: inline-block;
}

.detailed-view {
  border-right:solid 1px lightgrey;
}

@media screen and (max-width: 800px) {
  .validation_request_order_offer_agency_head {
    text-align: center;
    border:0;
    border-top:solid 1px lightgray;
    border-bottom: solid 1px lightgray;
    margin-top: 15px;
    padding-top: 15px;
    padding-bottom: 15px;

  }

  .validation_request_order_offer_agency_container{
    display: flex;
    border: 0;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .validation_request_order_offer_agency {
    /*width:30%;*/
    /*width: 25%;*/
    width: 100%;
    border-top:0;
    /*width: -webkit-fill-available;*/
  }
}
</style>



// WEBPACK FOOTER //
// client/components/Demands/Details/ValidationRequestable/Offer/Agency.vue